export class SearchAfterListResult<T> {
    Results: T[];
    Total: number;
    PreviousPageToken: string;
    NextPageToken: string;
    AsyncQueryId: string;
}